import { IDropdown } from '@app/shared/interfaces/dropdown';

export enum ETHNICITY {
  'American Indian or Alaska Native' = 1,
  'Asian' = 2,
  'Black or African American' = 3,
  'Hispanic or Latino' = 4,
  'Native Hawaiian or Other Pacific Islander' = 5,
  'White' = 6,
  'Not sure' = 7,
}

export const ETHNICITY_DROPDOWN: IDropdown<string>[] = Object.values(ETHNICITY)
  .filter((value) => isNaN(Number(value)) === true)
  .map((value) => ({ value: `${ETHNICITY[value]}`, label: value } as IDropdown<string>));
